// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React, { useEffect, useState } from "react";
import { Button, Modal, Tooltip } from "antd";
import { MobileOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { requestGetNewsPreview } from "../../../../../state/news/NewsEffects";
import {
  NewsPreviewResponseDTO,
  NewsThemeInfoResponseDTO
} from "../../../../../api/backend-openapi";
import i18n from "i18next";
import { useStore } from "effector-react";
import { NewsThemeStore } from "../../../../../state/newsTheme/NewsThemeStore";

export interface NewsPreviewButtonProps {
  newsId: string;
  iconButton: boolean;
  newsThemeId?: string;
}

const NewsPreviewButton: React.FunctionComponent<NewsPreviewButtonProps> = (
  props: NewsPreviewButtonProps
) => {
  const { newsId, iconButton, newsThemeId } = props;

  const newsThemeStore: NewsThemeInfoResponseDTO[] | null = useStore(
    NewsThemeStore
  );

  const newsTheme = newsThemeStore.find(n => n.id === newsThemeId);

  const [newsPreview, setNewsPreview] = useState<NewsPreviewResponseDTO | null>(
    null
  );

  useEffect(() => {
    if (newsId) {
      requestGetNewsPreview(newsId);
    }
  }, [newsId]);

  useEffect(() => {
    return requestGetNewsPreview.done.watch(({ result }) => {
      if (result.ok && result.data) {
        setNewsPreview(result.data);
      }
    });
  });

  const { t } = useTranslation();

  const [visible, setVisible] = useState<boolean>(false);

  const innerButton = iconButton ? (
    <Tooltip
      title={i18n.t("news_list.table.tooltip.preview")}
      mouseEnterDelay={0.2}
      placement="bottom"
    >
      <Button
        type="default"
        icon={<MobileOutlined />}
        size="large"
        className="btn-secondary mr-1 btn-list"
        onClick={() => setVisible(true)}
      />
    </Tooltip>
  ) : (
    <Button
      type="default"
      className="btn-secondary m-2"
      onClick={() => setVisible(true)}
    >
      <MobileOutlined />
      {t("detail_news.preview")}
    </Button>
  );

  return (
    <>
      {innerButton}
      <Modal
        className="news-preview"
        title={t("detail_news.preview")}
        visible={visible}
        centered
        footer={
          <Button key="closePreviewModal" onClick={() => setVisible(false)}>
            {t("global.close")}
          </Button>
        }
        onCancel={() => setVisible(false)}
        bodyStyle={{ padding: 0 }}
      >
        <div
          className="preview-theme"
          style={{ backgroundColor: newsTheme?.color }}
        >
          {newsTheme?.name}
        </div>
        {newsPreview && (
          <div
            /* eslint-disable-next-line @typescript-eslint/naming-convention */
            dangerouslySetInnerHTML={{ __html: newsPreview.content }}
          />
        )}
      </Modal>
    </>
  );
};

export default NewsPreviewButton;
